import { render, staticRenderFns } from "./Prog.vue?vue&type=template&id=650ed6e8&scoped=true&"
import script from "./Prog.vue?vue&type=script&lang=ts&"
export * from "./Prog.vue?vue&type=script&lang=ts&"
import style0 from "./Prog.vue?vue&type=style&index=0&id=650ed6e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650ed6e8",
  null
  
)

export default component.exports